import * as applicationActions from "../applications/actions";
import * as financingActions from "../financing/actions";
import * as ordersActions from "../orders/actions";
import * as borrowerOrdersActions from "../borrowerOrders/actions";

import { CALL_API } from "admin/middlewares/api";

//Used to format the dates correctly without timezone (ToDo add this globally somehow?)
import moment from "moment";

//ToDo some endpoints to menu commands
export function fetch_dashboard_loan_data() {
  return (dispatch) => {
    dispatch(applicationActions.get_applications());
    dispatch(financingActions.get_financings());
    dispatch(financingActions.get_loans_for_payout());
  };
}

export function fetch_new_loans_loan_data() {
  return (dispatch) => {
    dispatch(applicationActions.get_applications());
    dispatch(financingActions.get_financings());
    dispatch(financingActions.get_loans_for_payout());
  };
}

export function fetch_orders_data() {
  return (dispatch) => {
    dispatch(ordersActions.get_withdraws());
  };
}

export function fetch_borrower_orders_data() {
  return (dispatch) => {
    dispatch(borrowerOrdersActions.get_borrower_withdrawal_orders());
  };
}

export const STATISTICS_REQUEST = "STATISTICS_REQUEST";
export const STATISTICS_SUCCESS = "STATISTICS_SUCCESS";
export const STATISTICS_ERROR = "STATISTICS_ERROR";

export function fetch_statistics(date) {
  return {
    [CALL_API]: {
      endpoint:
        "/api/admin/transactions/systemday?Date=" +
        moment(date).format("YYYY-MM-DD"),
      method: "GET",
      authenticatedRequest: true,
      types: [STATISTICS_REQUEST, STATISTICS_SUCCESS, STATISTICS_ERROR],
    },
  };
}

export const DEPOT_REQUEST = "DEPOT_REQUEST";
export const DEPOT_SUCCESS = "DEPOT_SUCCESS";
export const DEPOT_ERROR = "STATISTICS_ERROR";

export function fetch_depots(date, depotId) {
  return {
    [CALL_API]: {
      endpoint:
        "/api/admin/transactions/depotday?Date=" +
        moment(date).format("YYYY-MM-DD") +
        "&DepotId=" +
        depotId,
      method: "GET",
      authenticatedRequest: true,
      types: [DEPOT_REQUEST, DEPOT_SUCCESS, DEPOT_ERROR],
    },
  };
}

export const DEPOT_RANGE_REQUEST = "DEPOT_RANGE_REQUEST";
export const DEPOT_RANGE_SUCCESS = "DEPOT_RANGE_SUCCESS";
export const DEPOT_RANGE_ERROR = "DEPOT_RANGE_ERROR";

export function fetch_depots_range(from, to, depotId) {
  return {
    [CALL_API]: {
      endpoint:
        "/api/admin/transactions/depotdayrange?From=" +
        moment(from).format("YYYY-MM-DD") +
        "&To=" +
        moment(to).format("YYYY-MM-DD") +
        "&DepotId=" +
        depotId,
      method: "GET",
      authenticatedRequest: true,
      types: [DEPOT_RANGE_REQUEST, DEPOT_RANGE_SUCCESS, DEPOT_RANGE_ERROR],
    },
  };
}
